/*
 * @Description:
 * @Author: HG
 * @Date: 2019-08-21 13:38:08
 * @LastEditors: HG
 * @LastEditTime: 2019-08-28 09:37:33
 */
import Vue from "vue";
import RoleQermissionComponent from "./RoleQermission.vue";
import RoleReportQermissionComponent from "./RoleReportQermission.vue";
import CompanyRoleQermissionComponent from "./CompanyRoleQermission.vue";

const RoleQermission = Vue.extend(RoleQermissionComponent);
const RoleReportQermission = Vue.extend(RoleReportQermissionComponent);
const CompanyRoleQermission = Vue.extend(CompanyRoleQermissionComponent);

const RoleQermissionModal = options => {
  if (Vue.prototype.$isServer) return;

  const {
    //autoClose,
    ...rest
  } = options;
  const instance = new RoleQermission({
    propsData: {
      ...rest
    },
    data: {
      //autoClose: autoClose === undefined ? 3000 : autoClose
    }
  });

  // const id = `SelectPicker`;
  // instance.id = id;
  instance.vm = instance.$mount();
  document.body.appendChild(instance.vm.$el);
  instance.vm.visible = true;

  //绑定 change 方法
  //   instance.vm.$on("change", selecteds => {
  //     if (instance.change) {
  //       instance.change(selecteds);
  //     }
  //   });
  instance.vm.$on("destroy", () => {
    document.body.removeChild(instance.vm.$el);
  });
  return instance.vm;
};

const RoleReportQermissionModal = options => {
  if (Vue.prototype.$isServer) return;

  const {
    //autoClose,
    ...rest
  } = options;
  const instance = new RoleReportQermission({
    propsData: {
      ...rest
    },
    data: {
      //autoClose: autoClose === undefined ? 3000 : autoClose
    }
  });

  // const id = `SelectPicker`;
  // instance.id = id;
  instance.vm = instance.$mount();
  document.body.appendChild(instance.vm.$el);
  instance.vm.visible = true;

  //绑定 change 方法
  //   instance.vm.$on("change", selecteds => {
  //     if (instance.change) {
  //       instance.change(selecteds);
  //     }
  //   });
  instance.vm.$on("destroy", () => {
    document.body.removeChild(instance.vm.$el);
  });
  return instance.vm;
};

const CompanyRoleQermissionModal = options => {
  if (Vue.prototype.$isServer) return;

  const {
    //autoClose,
    ...rest
  } = options;
  const instance = new CompanyRoleQermission({
    propsData: {
      ...rest
    },
    data: {
      //autoClose: autoClose === undefined ? 3000 : autoClose
    }
  });

  // const id = `SelectPicker`;
  // instance.id = id;
  instance.vm = instance.$mount();
  document.body.appendChild(instance.vm.$el);
  instance.vm.visible = true;

  //绑定 change 方法
  //   instance.vm.$on("change", selecteds => {
  //     if (instance.change) {
  //       instance.change(selecteds);
  //     }
  //   });
  instance.vm.$on("destroy", () => {
    document.body.removeChild(instance.vm.$el);
  });
  return instance.vm;
};

export {
  RoleQermissionModal,
  RoleReportQermissionModal,
  CompanyRoleQermissionModal
};
